import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { makeStyles } from '@material-ui/core/styles';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import Button from '@material-ui/core/Button';
import getPageName from './utils/getPageName';
import {
  Wrapper,
  HeaderWrapper,
  ExportButtonWrapper,
  ReportWrapper,
  MessageWrapper,
} from './styles/reportContainerStyles';
import exportCSVWrapper from '../HOCs/exportCSVWrapper';
import TransactionReportContainer from './TransactionReport/TransactionReport';
import LoyaltyReportContainer from './LoyaltyReport/LoyaltyReport';
import ProductReportContainer from './ProductReport/ProductReport';
import ComboReportContainer from './ComboReport/ComboReport';
import LocationReportContainer from './LocationReport/LocationReport';
import CustomerReportContainer from './CustomerReport/CustomerReport';
import OfferReport from './OfferReport/OfferReport';
import CouponReport from './CouponReport/CouponReport';
import ExportReport from './ExportReport/ExportReport';
import * as actions from './ReportTableActions.js';
import { connect } from 'react-redux';
import { CustomizationContext } from '../../utils/ClientCustomizationsProvider.js';
const TransactionMessageWrapper = styled.div`
  margin: 15px 0;
  padding: 0 12px;
  width: 100%;
`;
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  button: {
    width: '148px',
    backgroundColor: '#e6ebff',
    color: '#2440ae',
    height: '43px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    fontFamily: ['Montserrat', 'sans-serif'].join(','),
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#d9e0ff',
    },
    '&:disabled': {
      backgroundColor: '#eff2ff',
      color: '#9facdf',
    },
  },
}));
const ReportContainer = (props) => {
  const classes = useStyles();
  const { isMaryBrowns } = useContext(CustomizationContext);
  const [filteredLocations, setFilteredLocations] = useState([]);
  const currentPathName = props.history.location.pathname;
  const [selectedBusinessesIDs, setSelectedBusinessesIDs] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [maxDueDate, setMaxDueDate] = useState(null);
  const [exportingData, setExportingData] = useState([]);
  const [exportingHeaders, setExportingHeaders] = useState([]);
  const [exportingFileName, setExportingFileName] = useState('');
  const [message, setMessage] = useState('');
  const [queryParams, setQueryParams] = useState('');
  useEffect(() => {
    const selectedStartDate = moment(startDate)
      .set({ hour: 0, minute: 0, second: 0 })
      .format('YYYY-MM-DD HH:mm:ss');
    const selectedEndDate = moment(endDate)
      .set({ hour: 23, minute: 59, second: 59 })
      .format('YYYY-MM-DD HH:mm:ss');
    const params = {
      page_number: 1,
      page_size: 3000,
      start_datetime: selectedStartDate,
      end_datetime: selectedEndDate,
      export: true,
    };
    setQueryParams(params);
  }, [startDate, endDate, selectedBusinessesIDs]);
  const isTransactionReport = currentPathName === '/transaction-report';
  const isExportReportClient = currentPathName === '/export-report';

  return (
    <Wrapper>
      <HeaderWrapper>
        <BreadCrumb pageName={getPageName(currentPathName)} />
        {!isExportReportClient && !isTransactionReport && (
          <ExportButtonWrapper>
            <CSVLink
              data={exportingData}
              headers={exportingHeaders}
              filename={`${exportingFileName}.csv`}
              disabled={exportingData?.length === 0}
            >
              <Button
                className={classes.button}
                disabled={exportingData?.length === 0}
              >
                Export as CSV
              </Button>
            </CSVLink>
          </ExportButtonWrapper>
        )}
      </HeaderWrapper>
      {currentPathName === '/transaction-report' && (
        <TransactionMessageWrapper>
          {isMaryBrowns
            ? "You can access single-day reports with the 'Generate' button, or download comprehensive weekly and monthly reports via the 'Export' button."
            : "You can view instant reports with the 'Generate' button, or download comprehensive weekly and monthly reports via the 'Export' button."}
        </TransactionMessageWrapper>
      )}
      <ReportWrapper>
        {currentPathName === '/transaction-report' && (
          <TransactionReportContainer
            setExportingData={setExportingData}
            setExportingHeaders={setExportingHeaders}
            setExportingFileName={setExportingFileName}
            setMessage={setMessage}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedBusinessesIDs={selectedBusinessesIDs}
            setSelectedBusinessesIDs={setSelectedBusinessesIDs}
            maxDueDate={maxDueDate}
            setMaxDueDate={setMaxDueDate}
            filteredLocations={filteredLocations}
            setFilteredLocations={setFilteredLocations}
            history={props.history}
          />
        )}

        {currentPathName === '/loyalty-report' && (
          <LoyaltyReportContainer
            setExportingData={setExportingData}
            setExportingHeaders={setExportingHeaders}
            setExportingFileName={setExportingFileName}
            setMessage={setMessage}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedBusinessesIDs={selectedBusinessesIDs}
            setSelectedBusinessesIDs={setSelectedBusinessesIDs}
          />
        )}
        {currentPathName === '/product-performance-report' && (
          <ProductReportContainer
            setExportingData={setExportingData}
            setExportingHeaders={setExportingHeaders}
            setExportingFileName={setExportingFileName}
            setMessage={setMessage}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedBusinessesIDs={selectedBusinessesIDs}
            setSelectedBusinessesIDs={setSelectedBusinessesIDs}
            filteredLocations={filteredLocations}
            setFilteredLocations={setFilteredLocations}
          />
        )}
        {currentPathName === '/credit-code-report' && (
          <CouponReport
            setExportingData={setExportingData}
            setExportingHeaders={setExportingHeaders}
            setExportingFileName={setExportingFileName}
            setMessage={setMessage}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedBusinessesIDs={selectedBusinessesIDs}
            setSelectedBusinessesIDs={setSelectedBusinessesIDs}
            filteredLocations={filteredLocations}
            setFilteredLocations={setFilteredLocations}
          />
        )}
        {currentPathName === '/offer-report' && (
          <OfferReport
            setExportingData={setExportingData}
            setExportingHeaders={setExportingHeaders}
            setExportingFileName={setExportingFileName}
            setMessage={setMessage}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedBusinessesIDs={selectedBusinessesIDs}
            setSelectedBusinessesIDs={setSelectedBusinessesIDs}
            filteredLocations={filteredLocations}
            setFilteredLocations={setFilteredLocations}
          />
        )}
        {currentPathName === '/combo-performance-report' && (
          <ComboReportContainer
            setExportingData={setExportingData}
            setExportingHeaders={setExportingHeaders}
            setExportingFileName={setExportingFileName}
            setMessage={setMessage}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedBusinessesIDs={selectedBusinessesIDs}
            setSelectedBusinessesIDs={setSelectedBusinessesIDs}
            filteredLocations={filteredLocations}
            setFilteredLocations={setFilteredLocations}
          />
        )}
        {currentPathName === '/location-transaction-report' && (
          <LocationReportContainer
            setExportingData={setExportingData}
            setExportingHeaders={setExportingHeaders}
            setExportingFileName={setExportingFileName}
            setMessage={setMessage}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedBusinessesIDs={selectedBusinessesIDs}
            setSelectedBusinessesIDs={setSelectedBusinessesIDs}
            filteredLocations={filteredLocations}
            setFilteredLocations={setFilteredLocations}
          />
        )}
        {currentPathName === '/customer-report' && (
          <CustomerReportContainer
            setExportingData={setExportingData}
            setExportingHeaders={setExportingHeaders}
            setExportingFileName={setExportingFileName}
            setMessage={setMessage}
          />
        )}
        {currentPathName === '/export-report' && (
          <ExportReport
            setExportingData={setExportingData}
            setExportingHeaders={setExportingHeaders}
            setExportingFileName={setExportingFileName}
            setMessage={setMessage}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedBusinessesIDs={selectedBusinessesIDs}
            setSelectedBusinessesIDs={setSelectedBusinessesIDs}
            filteredLocations={filteredLocations}
            setFilteredLocations={setFilteredLocations}
          />
        )}
      </ReportWrapper>
      {message &&
        exportingData.length === 0 &&
        currentPathName !== '/export-report' && (
          <MessageWrapper>{message}</MessageWrapper>
        )}
    </Wrapper>
  );
};

export default connect(_, {
  ...actions,
})(exportCSVWrapper(ReportContainer));
